import forEach from '../../../../javascripts/dom/forEach';

const imageFrames = document.querySelectorAll('[data-js-module="o-image-frame"]');

const init = async () => {
  const { default: ImageFrame } = await import(/* webpackChunkName: "o-image-frame" */ './image-frame');
  forEach(imageFrames, (index, element) => new ImageFrame(element));
};

if (imageFrames.length) init();
